

function capitalizeFirstLetter(text) {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
}


function icon_cross(x, y, w, h) {
    var size = Math.min(w, h);
    var t = size / 3; // 臂的宽度，可以根据需要调整
    var c = x + size / 2; // 中心点 x 坐标
    var d = y + size / 2; // 中心点 y 坐标
    return [
        'M', c - t / 2, y,                    // 上臂左侧
        'L', c + t / 2, y,                    // 上臂右侧
        'L', c + t / 2, d - t / 2,            // 中心右上
        'L', x + size, d - t / 2,             // 右臂上侧
        'L', x + size, d + t / 2,             // 右臂下侧
        'L', c + t / 2, d + t / 2,            // 中心右下
        'L', c + t / 2, y + size,             // 下臂右侧
        'L', c - t / 2, y + size,             // 下臂左侧
        'L', c - t / 2, d + t / 2,            // 中心左下
        'L', x, d + t / 2,                    // 左臂下侧
        'L', x, d - t / 2,                    // 左臂上侧
        'L', c - t / 2, d - t / 2,            // 中心左上
        'Z'                                   // 闭合路径，形成实心填充
    ];
}

function icon_wye (x, y, w, h) {
    const size = Math.min(w, h); // 使用宽度和高度中最小的值
    const c = -0.5;
    const sqrt = Math.sqrt;
    const s = sqrt(3) / 2;
    const k = 1 / sqrt(12);
    const a = (k / 2 + 1) * 3; // 用于旋转效果的余弦值

    // 计算符号大小
    const r = sqrt((size * size) / a); // 根据最小尺寸 size 计算 r 值
    const x0 = r / 2, y0 = r * k;
    const x1 = x0, y1 = r * k + r;
    const x2 = -x1, y2 = y1;

    // 调整坐标，使图形居中
    const centerX = x + w / 2; // 计算图形中心点 X 坐标
    const centerY = y + h / 2; // 计算图形中心点 Y 坐标

    // 定义路径，确保图形居中
    return [
        'M', centerX + x0, centerY + y0, // 起点
        'L', centerX + x1, centerY + y1, // 左侧
        'L', centerX + x2, centerY + y2, // 底部
        'L', centerX + (c * x0 - s * y0), centerY + (s * x0 + c * y0), // 第一个旋转点
        'L', centerX + (c * x1 - s * y1), centerY + (s * x1 + c * y1), // 第二个旋转点
        'L', centerX + (c * x2 - s * y2), centerY + (s * x2 + c * y2), // 第三个旋转点
        'L', centerX + (c * x0 + s * y0), centerY + (c * y0 - s * x0), // 第四个旋转点
        'L', centerX + (c * x1 + s * y1), centerY + (c * y1 - s * x1), // 第五个旋转点
        'L', centerX + (c * x2 + s * y2), centerY + (c * y2 - s * x2), // 第六个旋转点
        'Z' // 闭合路径
    ];
}

export default  {
    capitalizeFirstLetter,
    icon_cross,
    icon_wye
}